<template>
  <div class="erp-app" :class="{ 'mobile-mode': isMobile }">
    <!-- 移动端头部 -->
    <MobileHeader 
      v-if="isMobile" 
      :user-name="userName"
      @open-sidebar="sidebarOpen = true"
    />

    <!-- 侧边栏抽屉 (移动端) -->
    <SidebarMobile
      v-if="isMobile"
      :visible="sidebarOpen"
      
      v-model="currentPage"
      :user-name="userName"
      @close="sidebarOpen = false"
    />

    <!-- PC端侧边栏 (固定) -->
    <SidebarPC 
      v-if="!isMobile"
      v-model="currentPage"
      
      :user-name="userName"
    />

    <!-- 主内容区域 -->
    <main class="main-content" :class="{ 'with-sidebar': !isMobile }">
      <!-- 面包屑/路径 -->
      <div class="breadcrumb">
        <span>微科斯</span>
        <!-- <span class="separator">›</span>
        <span>产品列表</span> -->
        <span class="separator">›</span>
        <span class="current">商品管理</span>
      </div>

      <!-- 控制台卡片 -->
      <!-- <div class="console-card">
        <div class="console-header">
          <span class="console-icon">⚙️</span>
          <span class="console-title">控制台</span>
        </div>
      </div> -->

      <!-- 系统类型卡片 -->
      <div class="system-type-card">
        <div class="type-label">系统类型</div>
        <div class="type-buttons">
          <button 
            v-for="type in originalData" 
            :key="type.categeroyId"
            class="type-btn"
            :class="{ active: selectedType === type.categeroyId }"
            @click="GetProducts(type.categeroyId)"
          >
            {{ type.categeroyName }}
          </button>
        </div>
      </div>

      <!-- 商品介绍卡片 -->
      <div class="intro-card">
        <div class="intro-header">
          <span class="letter-badge">A</span>
          <h3>商品介绍：</h3>
        </div>
        
        <!-- 产品图片区域 -->
        <div class="product-images">
          <!-- 主图 -->
          
          <div class="main-image"  v-if="imageUrls.length > 0">
            <img 
              :src="imageUrls[currentImage]"
             
              
            >
            <span class="image-badge">主图</span>
          </div>
          
          <!-- 缩略图列表 -->
          <div class="thumbnail-list">
            <div 
              v-for="(thumb, index) in imageUrls" 
              :key="index"
              class="thumbnail"
              :class="{ active: currentImage === index }"
              @click="currentImage = index"
            >
              <img :src="thumb" :alt="`产品图${index + 1}`">
            </div>
          </div>
        </div>

        <div class="intro-quote">
         <div v-if="mainProducts"  v-html="mainProducts.productDecription">
           
          </div>

          <p v-else>暂无主介绍商品</p>
       
        </div>
      </div>

      <!-- 功能模块表格 (带勾选框) -->
      <div class="table-card">
         <!-- 顶部工具栏：全选 + 已选计数 + 反选按钮 -->
    <div class="toolbar">
      <label class="checkbox-label">
        <input type="checkbox" v-model="allSelected" />
        <span>全选</span>
      </label>
      <span class="selected-info">已选 {{ selectedCount }} 项</span>
      <!-- <button class="inverse-btn" @click="inverseSelection">反选</button> -->
    </div>

    <!-- 表格主体 -->
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th class="checkbox-col"></th>
            <th>序号</th>
            <th>模块名称</th>
            <th>功能</th>
            <th>使用时间</th>
            <th>数量</th>
            <th>价格(元)</th>
          </tr>
        </thead>
        <tbody>
         <tr
            v-for="(row, index) in rows"
            :key="row.id"
            :class="{ 'child-row': row.type === 'sku' }"
          >
            <td class="checkbox-col">
              <input type="checkbox"  v-if="!(row.type === 'product' && row.hasChildren)" v-model="selectedIds" :value="row.id" />
            </td>
            <td>{{ row.sn }}</td>
            <td>{{ row.moduleName }}</td>
            <td>{{ row.function }}</td>
            <td>{{ row.days }}</td>
            <td>{{ row.quantity }}</td>
            <td>￥{{ row.price.toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
    </div>
        <!-- 底部汇总 -->
        <div class="table-footer">
          <div class="total-price">
            <span class="total-label">总价</span>
            <span class="price-amount">¥{{ totalPrice.toLocaleString() }}</span>
          </div>
          
          <div class="trial-notice">
            <span class="notice-icon">ⓘ</span>
            <span class="notice-text">*注意首次申请试用期为14天</span>
          </div>
          
          <div class="action-buttons">
            <button class="btn btn-outline">申请试用</button>
            <button class="btn btn-primary" @click="handleCheckout">结算</button>
          </div>
        </div>
      </div>

      <!-- 页脚 -->
      <Foot /> 
    </main>
     <!-- 支付宝支付弹窗 -->
    <el-dialog v-model="payDialogVisible" title="支付宝支付" width="420px" @close="closePayDialog">
      <div class="pay-box">
        <div class="qrcode-wrap">
         <div id="qrcodes" class="qrcode-container"></div>
       
           
          <p class="price">应付金额：¥{{ totalPrice.toLocaleString() }}</p> 
        </div>
        <div class="pay-btns">
           <!-- 渲染支付宝支付二维码 -->
         <!-- 二维码容器，用于QRCode渲染 -->
        
         <p class="tip">请使用支付宝APP扫码付款，5分钟内有效</p>
           <!-- <el-button @click="refreshQrcode">刷新二维码</el-button>
          <el-button type="primary" @click="checkPayStatus">已支付，查询结果</el-button>  -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import Foot from '@/components/layout/Foot.vue'
import { ref,nextTick, computed, onMounted, onUnmounted } from 'vue'
import SidebarPC from '@/components/layout/SidebarPC.vue'
import SidebarMobile from '@/components/layout/SidebarMobile.vue'
import MobileHeader from '@/components/layout/MobileHeader.vue'
import { ShopTypeEmun} from '@/httpRequest/ShopEmun';
 import {CreateShopOrder,GetOrdersOnlinePayment} from '@/httpRequest/orderRequest';
  import {AlipayAbnormalForOrderPay} from '@/httpRequest/PayRequest';
import {
  GetListBusinessCategory,categoryData,Productlist
} from "../httpRequest/ProductRequest";;
import { ElMessageBox, ElMessage } from 'element-plus'; 
   import { useRoute, useRouter } from "vue-router/dist/vue-router";
// 引入二维码插件
import QRCode from 'qrcodejs2'

 let pollTimer: number | null = null
    const payDialogVisible = ref(false)

        const router = useRouter()
 const closePayDialog = () => {
                            payDialogVisible.value = false
                            //   clearInterval(pollTimer)
                            clearInterval(pollTimer!)
                            pollTimer = null
                            // 清空二维码容器，防止重复叠加
                            const qrDom = document.getElementById('qrcodes')
                            if (qrDom) qrDom.innerHTML = ''
                }
           
// 支付弹窗

const qrcodeCanvas = ref(null)
 const currentImage = ref(0)
 const currentCategory = ref(1);
// 响应式状态
const isMobile = ref(false)
const sidebarOpen = ref(false)
const currentPage = ref('首页')
const selectedType = ref(0)
const selectedItems = ref<string[]>([]);
const userName = ref('admin')
 const products = ref([]);
const originalData = ref<categoryData[]>([]);
// 产品图片数据
const productImages = ref([])
// const productImages = ref([
//   'https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef94?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef95?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef96?w=400&h=400&fit=crop'
// ])
// //分类调用接口获取所有数据
const ListBusinessCategory = async (data: any) => {
  var getListBusinessCategory = await GetListBusinessCategory({
    categeroyId: data
  });
  debugger

  originalData.value = getListBusinessCategory.data;
  selectedType.value= getListBusinessCategory.data[0].categeroyId
  console.log("selectedType",selectedType.value);
   DealProductsdata(selectedType.value);
  //getListBusinessCategory.filter(p=>p.parentId==0).tolist();
};


 


// 系统类型
const systemTypes = ['物料标签管理系统', '电商系统', '电商ERP']

// 展平成行数据
const rows = computed(() => {
  const flat = [];
  let mainSn = 1; // 商品主序号

  products.value.forEach((product, index) => {
    const skus = product.productsGetSkuDto?.productsSkuInfoDto || [];
     const hasChildren = skus.length > 0;
    // 商品本身行
    flat.push({
      id: `p-${product.id}`,                // 唯一标识，加前缀避免与 skuId 冲突
      type: 'product',
      productid:product.id,
      skuid:'0',
      sn: mainSn,
      moduleName: product.productName,
      function: '',                          // 商品行功能留空
      proUnitNum:product.proUnitNum,
      proUnit:product.proUnit,
      days: product.proUnitNum+"("+product.proUnitName+")", // 示例：基础资料用180，其他用0
      quantity: product.stockQty || 1,
      price: product.price || 0,
      hasChildren
    });

    // 如果有 SKU，添加子行
   
     let subSn = 1;
    skus.forEach(sku => {
      flat.push({
        id: `s-${sku.skuId}`,
        productid:product.id,
        skuid:sku.skuId,
         proUnitNum:product.proUnitNum,
        proUnit:product.proUnit,
        type: 'sku',
        sn: `${mainSn}.${subSn}`, // 层级序号
        moduleName: product.productName,
        function: sku.productsSpecsValueId?.join(' / ') || '',
        days: product.proUnitNum+"("+product.proUnitName+")",                            // 示例：SKU 天数固定为111
        quantity: sku.stockQty || 1,
        price: sku.price || 0
      });
       subSn++;
    });
     mainSn++; // 处理下一个商品
  });
  return flat;
});

// 所有可选行的 id 列表
const allIds = computed(() =>
  rows.value
    .filter(row => !(row.type === 'product' && row.hasChildren))
    .map(row => row.id)
);

// 当前选中的 id 列表
const selectedIds = ref([]);

// 全选计算属性
const allSelected = computed({
  get: () => selectedIds.value.length === allIds.value.length,
  set: (value) => {
    if (value) {
      selectedIds.value = [...allIds.value]; // 全选
    } else {
      selectedIds.value = []; // 全不选
    }
  }
});

// 已选数量
const selectedCount = computed(() => selectedIds.value.length);

// 总价计算（选中项的价格 × 数量之和）
const totalPrice = computed(() => {
  let total = 0;
  rows.value.forEach(row => {
    if (selectedIds.value.includes(row.id)) {
      total += row.price * row.quantity;
    }
  });
  return total;
});

// 反选：将当前选中状态取反
// const inverseSelection = () => {
//   const all = allIds.value;
//   const currentlySelected = selectedIds.value;
//   const newSelected = all.filter(id => !currentlySelected.includes(id));
//   selectedIds.value = newSelected;
// };

// 检测屏幕尺寸
const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 768
}




// 方法
 

 

const DealProductsdata=(selectedTypes:any )=>
{

var getProducts=Productsdata(1,selectedTypes);
console.log(getProducts);


}
const GetProducts=(selectedTypes:any )=>{
selectedType.value=selectedTypes;
  DealProductsdata(selectedTypes);
}
const Productsdata = async (pageIndex: any, fullCategoryIds: any) => {
   // 商品数据
               
                 var listInfo = await Productlist({
                        pageIndex: pageIndex,
                        pageSize: 500,
                        shopTypeStatus: ShopTypeEmun.MayfousErp,
                        CategoryId: fullCategoryIds
                });
                
                 products.value = listInfo.data.list;
                 console.log("products.value",products.value)
                 }
// 生命周期
onMounted(() => {
  ListBusinessCategory(200000000000);
  console.log("selectedTypesss",selectedType.value);
  
 
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
})


// 过滤出 isMainIntroduction 为 true 的项
const mainProducts = computed(() => {
  return products.value.find(item => item.isMainIntroduction === true);
});

// 将 SKU 数据扁平化，每个 SKU 生成一行，无 SKU 的产品生成一行占位
 

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize)
})


// 将 SKU 数据扁平化，每个 SKU 生成一行，无 SKU 的产品生成一行占位
const flattenedSkus = computed(() => {
  const rows = [];
  var productIndex = 1; // 产品主序号（从1开始）
          
  products.value.forEach(product => {
  const skuList = product.productsGetSkuDto?.productsSkuInfoDto || [];
    if (skuList && skuList.length > 0) {
      // 有 SKU：每个 SKU 生成一行，序号为 主序号.子序号
       rows.push({
              id: `p-${product.id}`,                
          serial: `${productIndex}`,
         productId:product.id,
         skuid:"0",
        productName: product.productName,
        specValue: null,
        price: undefined,
        stockQty: undefined
      });
      skuList.forEach((sku, idx) => {
        rows.push({
           id: `s-${sku.skuId}`,
           serial: `${productIndex}.${idx + 1}`,
           productId:product.id,
           skuid:sku.skuId,
          productName: product.productName,
          specValue: sku.productsSpecsValueId.join(', '), // 多个规格值用逗号连接
          price: sku.price,
          stockQty: sku.stockQty
        });
      });
    } else {
      
      // 无 SKU 的产品，添加一行占位
      rows.push({
             id: `p-${product.id}`,       
         serial: `${productIndex}`,
          productId:product.id,
          skuid:"0",
        productName: product.productName,
        specValue: null,
        price: product.price,
        stockQty: product.stockQty,
      });
       
        console.log("productIndex",productIndex);
        
    }
     productIndex++; // 产品主序号递增
  });
  console.log("rows",rows);
  
  return rows;
});
// 使用计算属性合并所有商品的 imgs 数组
const productImagess = computed(() => {
  // 确保 products.value 是数组
  if (!Array.isArray(products.value)) return [];
  // 用 flatMap 将每个商品的 imgs 数组合并成一个
  return products.value.flatMap(item => item.imgs || []);
});

// 如果需要仅提取图片 URL 列表
const imageUrls = computed(() => productImagess.value.map(img => img.imageUrl));


const extractSelectedItems = (selectedRows) => {
 const productMap = new Map(); // key: productid

  selectedRows.forEach(row => {
    const productId = row.productid;
    const skuId = row.skuid;

    if (!productMap.has(productId)) {
      productMap.set(productId, { productId, skuIds: [] });
    }

    const entry = productMap.get(productId);

    // 如果是 SKU 行且 skuid 有效
    if (row.type === 'sku' && skuId && skuId !== '0') {
      if (!entry.skuIds.includes(skuId)) {
        entry.skuIds.push(skuId); // 去重
      }
    }
    // 商品行不需要额外处理，只保证条目存在即可
  });

  return Array.from(productMap.values());
};
// 结算功能
const handleCheckoutA = async () => {


  // const qrCodeString = "https://qr.alipay.com/bax036462l37zve42p5j00d9"
  // payDialogVisible.value = true;
  // const qrDom = document.getElementById('qrcodes')
  // if (qrDom) qrDom.innerHTML = ''
  // await nextTick();

  // // //   关键：清空容器，防止二维码叠加
  // // //   3. 获取DOM，增加判空兜底，防止null报错
  // new QRCode(document.getElementById("qrcodes"), {
  //   text: qrCodeString,
  //   width: 200,
  //   height: 200
  // });
                      
  };
const handleCheckout = async () => {
   if (selectedCount.value === 0) {
    ElMessage.warning('请先选择要结算的项');
    return;
  }
      const generateOrderNo = () => {
                    const timestamp = Date.now()
                    const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
                    return `ORD${timestamp}${random}`
                }
                
   const pendingOrder = ref({
                    orderNo: '',
                    items: [],
                    totalAmount: 0,
                    originalAmount: 0,
                    savedAmount: 0,
                    itemCount: 0,
                    createTime: ''
                })
    const selectedRows = rows.value.filter(row => selectedIds.value.includes(row.id));
  //  console.log("selectedRows", JSON.stringify(selectedRows, null, 2));
     // // 生成订单数据
                    const orderItems = selectedRows.map(item => ({
                       
                        productId: item.productid,
                        proUnitNum: item.proUnitNum,
                        proUnit: item.proUnit,
                        productSkuId: item.skuid,
                        productName: item.moduleName,
                        productSkuName:item.function,
                        productImgUrl:imageUrls.value[0],
                        price: item.price,
                       // originalPrice: item.originalPrice,
                        quantity: item.quantity,
                        subtotal: item.price * item.quantity
                    }))
                         const total = totalPrice.value;
                    console.log("orderItems",orderItems)
        pendingOrder.value = {
                        orderNo: generateOrderNo(),
                        items: orderItems,
                        totalAmount:total,
                        originalAmount: 0,
                        savedAmount:0 ,
                        itemCount: selectedCount.value,
                        createTime: new Date().toLocaleString()
                    }

                      console.log("pendingOrder",pendingOrder.value)
                         const requestData = {
                          IsNotOrdersDeliveryDetails:true,
                        ordersDeliveryDetailsDto: null,
                        listOrdersDetailsDto: pendingOrder.value.items.map(item => ({
                            quantity: item.quantity,
                            productId: item.productId,
                            productSkuId: item.productSkuId,
                              proUnitNum: item.proUnitNum,
                        proUnit: item.proUnit,
                        }))
                    }
                       console.log('提交数据:', requestData)
                         var CreateShopOrderData = await CreateShopOrder(requestData);
                           console.log("CreateShopOrderData", CreateShopOrderData);
                    if (CreateShopOrderData.data.status == true) {
                        ElMessage.success(CreateShopOrderData.data.msg);

                           var aass = {
                            "orderId": CreateShopOrderData.data.data.orderPayId,
                            "classID": 2221010
                        }

                         var code=await AlipayAbnormalForOrderPay(aass)
                         if (code.data.status == true) {
                           payDialogVisible.value = true;
                             // 清空旧二维码
                          await nextTick()
                           // 清空二维码容器，防止重复叠加
                            const qrDom = document.getElementById('qrcodes')
                            if (qrDom) qrDom.innerHTML = ''
                             // // 你提供的原生二维码生成代码，直接搬入Vue
                              new QRCode(document.getElementById("qrcodes"), {
                                  text: code.data.data,
                                  width: 200,
                                 height: 200
                              });
                             // 开启2秒一次轮询查询支付状态
                             pollTimer = window.setInterval(() => {
                                 queryOrderPayStatus(CreateShopOrderData.data.data.orderPayId)
                             }, 3000)
                              
                         }

                        
                    } else {
                        ElMessage.warning("添加失败" ,CreateShopOrderData.data.msg);
                    }
 
      console.log("total", total);
      // const checkoutData = extractSelectedItems(selectedRows);
      // console.log('结算数据：', checkoutData);
// ElMessageBox.confirm(
//     `确认结算选中的 ${selectedCount.value} 项，总价 ￥${total.toLocaleString()} 吗？`,
//     '结算确认',
//     {
//       confirmButtonText: '确定',
//       cancelButtonText: '取消',
//       type: 'info'
//     }
//   ).then(() => {
//     // 模拟提交订单
//     console.log('结算数据：', selectedRows);
//     ElMessage.success('结算成功！订单已提交');
//     // 可选：跳转到订单页面或清空选中
//     // selectedIds.value = [];
//   }).catch(() => {
//     ElMessage.info('取消结算');
//   });

  }

  const queryOrderPayStatus = async (orderId: string) => {
      var aass = {
                            "Id ":orderId,
                            "ClassID": 2221010
                        }
  const res = await GetOrdersOnlinePayment(aass)
  const status = res.data.payStatusId;
  // 1. 支付成功分支
  if (status === 2161020) {
    clearInterval(pollTimer!)
    pollTimer = null
    payDialogVisible.value = false
    // 跳转支付宝支付成功页面，携带订单参数
    router.push({
      path: '/Alipay/AlipaySuccess',
      query: {
        orderId: orderId,
        amount: totalPrice.value,
        tradeNo: res.data.tradeNo // 后端返回支付宝交易号
      }
    })
  }
  // 2. 订单超时/关闭（支付失败）
  //if (status === 'timeout' || status === 'closed')
   if (status === 2161030) {
    clearInterval(pollTimer!)
    pollTimer = null
    showQrcodeModal.value = false
    ElMessage.warning('订单已超时/取消，请重新提交订单')
  }
}
</script>

<style scoped>
/* 二维码容器：图片自动居中 */
.qrcode-container {
  width: 260px;
  height: 260px;
  margin: 0 auto; /* 容器自身水平居中 */
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-box {
  text-align: center;
}
.qrcode-wrap canvas {
  margin: 10px auto;
}
.tip {
  color: #666;
  margin: 4px 0;
}
.price {
  font-size: 18px;
  color: #f56c6c;
  font-weight: bold;
}
/* 子行缩进（SKU行） */
.child-row td:first-of-type {
  padding-left: 40px;
}
.selected-info {
  font-size: 0.9rem;
  color: #0066cc;
  background: #e2f0ff;
  padding: 4px 12px;
  border-radius: 30px;
}
.inverse-btn {
  padding: 4px 12px;
  background: #e6f0ff;
  border: 1px solid #b9d3ff;
  border-radius: 30px;
  color: #0066cc;
  font-size: 0.85rem;
  cursor: pointer;
  transition: 0.2s;
}

.inverse-btn:hover {
  background: #0066cc;
  color: white;
}
/* 产品图片区域 */
.product-images {
  margin-bottom: 20px;
}

.main-image {
  position: relative;
  width: 100%;
  height: 250px;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 2px solid #e0ecff;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #0066cc;
  color: white;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 0.8rem;
}

.thumbnail-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.thumbnail {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: 0.2s;
}

.thumbnail.active {
  border-color: #0066cc;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 其他样式保持不变，从原文件中复制 */
.erp-app {
  min-height: 100vh;
  background: #f5f9ff;
  display: flex;
}

.mobile-mode {
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.main-content.with-sidebar {
  padding: 24px 32px;
}

/* 面包屑 */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  color: #5e7fa0;
  font-size: 0.9rem;
  flex-wrap: wrap;
}

.separator {
  color: #b6ceff;
}

.current {
  color: #003366;
  font-weight: 500;
}

/* 卡片通用样式 */
.console-card,
.system-type-card,
.intro-card,
.table-card {
  background: white;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #d6e5ff;
  box-shadow: 0 4px 12px rgba(0, 51, 102, 0.05);
}

/* 控制台卡片 */
.console-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.console-icon {
  background: #0066cc;
  color: white;
  width: 44px;
  height: 44px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.console-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #00315e;
}

/* 系统类型卡片 */
.type-label {
  color: #4e6f94;
  margin-bottom: 12px;
  font-size: 0.9rem;
}

.type-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.type-btn {
  background: #f0f7ff;
  border: 1px solid #c7ddff;
  padding: 8px 16px;
  border-radius: 30px;
  font-size: 0.9rem;
  color: #1a4470;
  cursor: pointer;
  transition: 0.2s;
  white-space: nowrap;
}

.type-btn.active {
  background: #0066cc;
  border-color: #0066cc;
  color: white;
}

/* 商品介绍卡片 */
.intro-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.letter-badge {
  background: #0066cc;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.3rem;
}

.intro-header h3 {
  font-size: 1.2rem;
  color: #003060;
}

.intro-quote {
  background: #f0f8ff;
  border-radius: 16px;
  padding: 16px 20px;
  border-left: 4px solid #0066cc;
  color: #1f4068;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* 表格卡片 */
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0ecff;
}
.table-container {
  background: white;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #d6e5ff;
  box-shadow: 0 4px 12px rgba(0, 51, 102, 0.05);
  max-width: 1000px;
  margin: 0 auto;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0ecff;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #1e4870;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.selected-count {
  background: #e2f0ff;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 0.9rem;
  color: #0066cc;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

th {
  background: #e2eeff;
  padding: 14px 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #00356b;
  text-align: center;
  border-bottom: 2px solid #99bdff;
}

td {
  padding: 12px 8px;
  border-bottom: 1px solid #dae6ff;
  text-align: center;
  font-size: 0.9rem;
  color: #1e3d63;
}

.checkbox-th,
.checkbox-td {
  width: 40px;
  text-align: center;
}

.checkbox-th input,
.checkbox-td input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.price-cell {
  color: #f56c6c;
  font-weight: 500;
}

.sub-row {
  background: #f4faff;
}

.sub-row td:first-of-type {
  padding-left: 40px;
}

/* 表格底部 */
.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e0ecff;
  flex-wrap: wrap;
  gap: 16px;
}

.total-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.total-label {
  font-size: 0.9rem;
  color: #4e6f94;
}

.price-amount {
  font-size: 1.3rem;
  font-weight: 700;
  color: #f56c6c;
}

.trial-notice {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #e5f1ff;
  padding: 8px 20px;
  border-radius: 40px;
  border: 1px solid #b9d3ff;
  color: #003f80;
  font-size: 0.9rem;
}

.notice-icon {
  background: #0066cc;
  color: white;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 30px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: 0.2s;
}

.btn-outline {
  background: white;
  border: 2px solid #0066cc;
  color: #0066cc;
}

.btn-outline:hover {
  background: #e2f0ff;
}

.btn-primary {
  background: #0066cc;
  color: white;
}

.btn-primary:hover {
  background: #004c99;
}

/* 页脚 */
.footer {
  margin-top: 30px;
  text-align: center;
}

.copyright {
  color: #6f8db0;
  font-size: 0.8rem;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .main-content {
    padding: 16px;
  }
  
  .main-content.with-sidebar {
    padding: 16px;
  }
  
  .action-buttons {
    flex-direction: column;
    width: 100%;
  }
  
  .btn {
    width: 100%;
    padding: 14px;
  }
  
  .table-footer {
    flex-direction: column;
    align-items: stretch;
  }
  
  .total-price {
    justify-content: center;
  }
  
  .trial-notice {
    justify-content: center;
  }
}
</style>